import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateComplain from "./createComplain";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import {
  raiseComplain, getFormDropdowns, getComplains, fetchFaqs
} from "services/redux/fileComplain/action"

const mapStateToProps = (state) => ({
  formDropdowns: state.fileComplainReducer.formDropdowns,
  fileComplainRaised: state.fileComplainReducer.fileComplainRaised,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getFormDropdowns,
    documentUploadUrl,
    raiseComplain,
    getComplains,
    fetchFaqs,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateComplain);
